// extracted by mini-css-extract-plugin
export default {"dateWrapper":"ui-date-field_dateWrapper__1y8JT","MuiOutlinedInput-root":"ui-date-field_MuiOutlinedInput-root__QdJR6"};